/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Check_TitleInputs */

const cs_portals_check_title = /** @type {(inputs: Portals_Check_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontrola exportu na portál`)
};

const en_portals_check_title = /** @type {(inputs: Portals_Check_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portal export check`)
};

/**
* | output |
* | --- |
* | "Portal export check" |
*
* @param {Portals_Check_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_check_title = /** @type {((inputs?: Portals_Check_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Check_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_check_title(inputs)
	return cs_portals_check_title(inputs)
});